import type { WebsiteComponentsTranslationsShape } from '@grammarly/website-components'
import websiteComponentsTranslationsEs from '@lib/i18n/translations/website-components/es.json'
import { Lang } from '@lib/utils/locale'

export type TranslationsDictionary = {
  websiteComponents?: WebsiteComponentsTranslationsShape
}

export const defaultTranslations: TranslationsDictionary = {
  websiteComponents: undefined,
}

function loadWebsiteComponentsTranslations(lang: Lang): WebsiteComponentsTranslationsShape | undefined {
  // P0 implementation, pull from static local file.

  // P1 - Dynamically import the dictionary based on the locale
  /* TODO - how to do type check while using dynamic import?
   *  Should we use dynamic import?
   *  Should we key the keys programmatically instead (bad runtime cost)?
   */
  // TODO - need to test how this handles when it fails/translations are missing
  // const translations = await import(`@lib/i18n/translations/website-components/${locale}.json`)

  switch (lang) {
    case 'es':
      return websiteComponentsTranslationsEs
    default:
      // English
      return undefined
  }
}

export function loadTranslations(lang: Lang): TranslationsDictionary {
  return {
    websiteComponents: loadWebsiteComponentsTranslations(lang),
  }
}
